import { axiosTemplate } from '../../axiosTemplate';
export const movCyclones = {
    endpoints: {
        test: `https://ad4r69stuc.execute-api.us-east-1.amazonaws.com/test`,
        acceptance: `https://3j4gc67or7.execute-api.us-east-1.amazonaws.com/acceptance`,
        prod: `https://hl99ndc3mg.execute-api.us-east-1.amazonaws.com/prod`,
    },
    http: {
        active: ({ query, stage, token, cancelToken }) => {
            const queryString = Object.keys(query)
                .map((key) => key + '=' + query[key])
                .join('&');
            return axiosTemplate(token, cancelToken).get(`${movCyclones.endpoints[stage]}/cyclones/active/paths?${queryString}`);
        },
        activePositions: ({ query, stage, token, cancelToken }) => {
            const queryString = Object.keys(query)
                .map((key) => key + '=' + query[key])
                .join('&');
            return axiosTemplate(token, cancelToken).get(`${movCyclones.endpoints[stage]}/cyclones/active/positions?${queryString}`);
        },
    },
};
